module.exports = __webpack_public_path__ + "media/images/logo-blanco-cuota-facil-svg-69b08d3ad0083e310a2baabe2e99131d.svg";